import { Grid } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Colors } from '../../../theme/colors';
import { SVGIconComponent } from '../icons/types';
import { ProjectLogo } from '../project-logo/project-logo.component';
import { useDeliveryCardStyles } from './delivery-card.styles';

export type DeliveryCardProps = {
  title?: string;
  descriptions: string[];
  Icon: SVGIconComponent;
  StatusBadge?: () => JSX.Element;
  image?: string;
  imageFallback?: string;
  withBorder?: boolean;
  isMasked?: boolean;
  link?: string;
};

export function DeliveryCard({
  title,
  descriptions,
  Icon,
  StatusBadge,
  image,
  imageFallback,
  withBorder = false,
  isMasked = false,
  link
}: DeliveryCardProps) {
  const classes = useDeliveryCardStyles({ withBorder, isMasked });
  return (
    <DeliveryCardWrapper link={link}>
      <Grid
        container
        className={classes.root}
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        {/* Left side contains the Delivery Type Icon and Descriptions list */}
        <Grid>
          <Grid container direction="row" spacing={2} wrap="nowrap">
            <Grid className={classes.iconWrapper}>
              <Icon color={Colors.midLightGray} />
            </Grid>
            <Grid>
              {title && <h1 className={classes.title}>{title}</h1>}
              <ul className={classes.descriptionList}>
                {descriptions.map((description) => (
                  <li key={description} className={classes.descriptionText}>
                    {description}
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Grid>

        {/* Right side contains Status Badge and Logo */}
        {StatusBadge && (
          <Grid>
            <Grid
              container
              spacing={1}
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexDirection: 'column'
              }}
            >
              <Grid>
                <StatusBadge />
              </Grid>
              <Grid>
                {image && <ProjectLogo imageURL={image} alt={imageFallback} />}
                {imageFallback && !image && <p>{imageFallback}</p>}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </DeliveryCardWrapper>
  );
}

function DeliveryCardWrapper(props: PropsWithChildren<{ link?: string }>) {
  if (props.link) {
    return <Link to={props.link}>{props.children}</Link>;
  }
  return <>{props.children}</>;
}
